/*
 * File: form-tree-select.ts
 * File Created: 2024-02-26 07:39:58
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 12:34:42
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import { IEntityPrimaryKey } from "@root/components/interfaces";
import { IQuickUnit } from "@root/core/utilities/quick-helper";
import { UITag } from "@root/core/tags";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
@UITag.setDefault({
    uiRelationConnect: true,
})
export default class FormTreeSelect extends BaseFormComponent {
    @PropInnateSync("value", { type: Object, default: undefined })
    innateValue!: IEntityPrimaryKey | undefined;

    @Prop({ type: Array, required: true })
    quicks!: IQuickUnit[];

    @Prop({ type: Object, required: false })
    params: NonNullable<any> | undefined;

    /// private helpers
    // required validation for textarea
    @makeRequiredValidator({
        validator: (o) =>
            !(
                o.value === "" ||
                o.value == null ||
                (Array.isArray(o.value) && o.value.length == 0)
            ),
    })
    defaultRequired() {
        return undefined;
    }
}
